exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title[data-v-df811c3a] {\n  font-size: 20px;\n}\n.code-input[data-v-df811c3a] {\n  border-color: var(--theme-gray);\n  padding: 10px 15px 10px 15px;\n}\n.code-input[data-v-df811c3a]::-webkit-input-placeholder {\n  color: var(--theme-gray);\n}\n.code-input[data-v-df811c3a]::-moz-placeholder {\n  color: var(--theme-gray);\n}\n.code-input[data-v-df811c3a]::-ms-input-placeholder {\n  color: var(--theme-gray);\n}\n.code-input[data-v-df811c3a]::placeholder {\n  color: var(--theme-gray);\n}\n.code-input[data-v-df811c3a]:focus {\n  border-color: var(--theme-gray);\n  outline: none;\n}\n.visible[data-v-df811c3a] {\n  visibility: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-df811c3a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registration/forms/PersonalForm.vue
// module id = 692
// module chunks = 0